import axios from 'axios'
import appConfig from '@/configs/app.config'
import { TOKEN_TYPE, REQUEST_HEADER_AUTH_KEY } from '@/constants/api.constant'
import { PERSIST_STORE_NAME } from '@/constants/app.constant'
import deepParseJson from '@/utils/deepParseJson'
import { readPersistedAccessToken } from './readPersistedAccessToken'
import store, { signOutSuccess } from '../store'
import { HttpCodes } from '@/constants/api.constant'
import {  setDbName } from '@/store'


const unauthorizedCode = [401]

const DB_LABELS: Record<string, string> = {
   'spotower-prod-kidonv3-aurora-cluster-new.cluster-c1c3obgmz70n.us-east-1.rds.amazonaws.com': 'Production',
   'spotower-prod-kidonv3-aurora-cluster-new.cluster-ro-c1c3obgmz70n.us-east-1.rds.amazonaws.com': 'Replica',
   'spotower-stage-kidonv3-aurora-cluster.cluster-c1c3obgmz70n.us-east-1.rds.amazonaws.com': 'Staging',
   'spotower-dev-kidonv3-aurora-cluster.cluster-c1c3obgmz70n.us-east-1.rds.amazonaws.com': 'Shadow',
}

// axios.create() does not inherit default interceptors. RTK uses BaseService; a lot of pages call axios directly. Both must read the header.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const rememberDb = (headers?: any) => {
   const host = headers?.['x-db-version']
   if (typeof host !== 'string' || !host) return
   const dbVersion = DB_LABELS[host] || host
   if (store.getState().locale.currentDB !== dbVersion) store.dispatch(setDbName(dbVersion))
}

const BaseService = axios.create({
   timeout: 60000,
   baseURL: appConfig.apiPrefix,
})


BaseService.interceptors.request.use(
   (config) => {
       const rawPersistData = localStorage.getItem(PERSIST_STORE_NAME)
       const persistData = deepParseJson(rawPersistData)


       let accessToken = readPersistedAccessToken(persistData)


       if (!accessToken) {
           const { auth } = store.getState()
           accessToken = auth.session.token
       }


       if (accessToken) {
           config.headers[
               REQUEST_HEADER_AUTH_KEY
           ] = `${TOKEN_TYPE}${accessToken}`
       }


       return config
   },
   (error) => {
       return Promise.reject(error)
   }
)
axios.interceptors.response.use(
   function (response) {
       rememberDb(response.headers)
       return response
   },
   function (error) {
       rememberDb(error?.response?.headers)
       if (error?.response?.status === HttpCodes.Unauthorized) store.dispatch(signOutSuccess())
       return Promise.reject(error)
   }
)




BaseService.interceptors.response.use((response) => {
   rememberDb(response.headers)
   return response
}, (error) => {
   rememberDb(error?.response?.headers)
   const { response } = error
   if (response && unauthorizedCode.includes(response.status)) store.dispatch(signOutSuccess())
   return Promise.reject(error)
})


export default BaseService
